import React from 'react';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { removeSession } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common';
import loginRedirect from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Login/LoginRedirect';
import logoutButton from 'assets/images/logout-button.png';
import logoutSelectedButton from 'assets/images/logout-selected-button.png';
import ImageButton from './ImageButton';

const t = (key: string) => translate('a11y', key);

const LogoutButton: React.FC = () => {
  const logoutStudent = () => {
    removeSession();
    loginRedirect();
  };
  return (
    <ImageButton
      hoveredImgSrc={logoutSelectedButton}
      notHoveredImgSrc={logoutButton}
      imgAlt={t('alt.logoutButton')}
      onClick={logoutStudent}
    />
  );
};

export default LogoutButton;
